import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Homepage from '@hobs/components/Homepage';
import './Home.scss';
import Loader from '@hobs/components/Loader';
import { getExerciseHomePage } from '../../actions/exercises';

class Home extends React.PureComponent {
  static propTypes = {
    getExerciseHomePage: PropTypes.func,
    auth: PropTypes.object,
    page: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  };

  componentDidMount() {
    this.props.getExerciseHomePage();
  }

  componentDidUpdate(prevProps) {
    const { CurrentExerciseId } = this.props.auth.user;
    if (
      prevProps &&
      CurrentExerciseId !== prevProps.auth.user.CurrentExerciseId
    ) {
      this.props.getExerciseHomePage();
    }
  }

  render() {
    const { page } = this.props;

    return page ? (
      <Homepage
        informationText={this.props.page.informationText}
        attachments={this.props.page.attachments}
      />
    ) : (
      <Loader />
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  page: state.exercises.currentPage
});

const mapDispatchToProps = dispatch => {
  return {
    getExerciseHomePage: id => dispatch(getExerciseHomePage(id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Home));
